import styles from '../PasswordManagement.module.less';

import { CallToAction, Col, Row } from '$HVUI';

export default function ConfirmEmailLanding() {
    return (
        <Row align="middle" justify="center">
            <Col span={8} className={styles['form-container']}>
                <h1>Welcome to Healthvana</h1>
                <p>
                    Thank you for signing up for Healthvana. Please check the
                    email address you provided for a link to confirm your new
                    account. If you're having trouble, please{' '}
                    <a href="https://healthvana.com/contact/">contact us</a>.
                </p>
                <CallToAction
                    text="Return to Login"
                    href="/"
                    style={{ margin: 'auto' }}
                    level="primary"
                />
            </Col>
        </Row>
    );
}
